import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'gameorderdetail.html',
})
export class GameOrderDetailPage {
    order;
    states = [];
    moneyMode = [
        { money: 1, name: '1元' },
        { money: 2, name: '2元' },
        { money: 0.1, name: '1角' },
        { money: 0.2, name: '2角' },
        { money: 0.02, name: '2分' }
    ];
    constructor(
        private viewctrl: ViewController,
        private navpars: NavParams
    ) {
        this.order = this.navpars.get('order');
        this.order.UnitName = this.moneyMode.find(f => f.money == this.order.Unit).name;
        this.states = this.navpars.get('states');
    }

    dismiss() {
        this.viewctrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/vrgamereport/gameorderdetail.ts